import { render } from "./EditRoleComponent.vue?vue&type=template&id=07ea7152"
import script from "./EditRoleComponent.vue?vue&type=script&lang=js"
export * from "./EditRoleComponent.vue?vue&type=script&lang=js"

import "./EditRoleComponent.vue?vue&type=style&index=0&id=07ea7152&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__